import { Component } from '@angular/core';

@Component({
  selector: 'form-editor-switch-wrapper',
  templateUrl: './switch-wrapper.component.html',
  styleUrls: ['./switch-wrapper.component.css']
})
export class SwitchWrapperComponent {}
